export default __webpack_public_path__ + "static/media/HAR_Logo.5bd9a410.svg";